export default { sha: '52fb0012242bff894cb06f085e32505bfc62934c', buildNumber: 'undefined' }
